import { useEffect, useState } from "react";
import Fingerprint2 from "fingerprintjs2";

const extractComponentData = (components) => {
  if (!components) return {};

  const componentMap = {};
  components.forEach((comp) => {
    componentMap[comp.key] = comp.value;
  });

  return {
    browser: componentMap.userAgent?.split("Chrome")
      ? "Chrome"
      : componentMap.userAgent?.split("Firefox")
      ? "Firefox"
      : componentMap.userAgent?.split("Safari")
      ? "Safari"
      : "Other",
    osName: componentMap.navigator_platform,
    screenResolution: componentMap.screen_resolution,
    screenColorDepth: componentMap.screen_color_depth,
    timezone: componentMap.timezone_offset,
    language: componentMap.navigator_language,
    userAgent: componentMap.user_agent,
    webGLVendor: componentMap.webgl_vendor,
    webGLRenderer: componentMap.webgl_renderer,
    hasWebGL: componentMap.webgl_vendor ? "yes" : "no",
    hasLocalStorage: componentMap.local_storage ? "yes" : "no",
    hasSessionStorage: componentMap.session_storage ? "yes" : "no",
    hasIndexedDB: componentMap.indexed_db ? "yes" : "no",
    openDatabase: componentMap.open_database ? "yes" : "no",
    cpuClass: componentMap.cpu_class,
    deviceMemory: componentMap.device_memory,
    plugins: componentMap.plugins,
    canvas: componentMap.canvas,
    webDriver: componentMap.webdriver ? "yes" : "no",
  };
};

export const useFingerprint = () => {
  const [fingerprint, setFingerprint] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const getFingerprint = async () => {
      try {
        const components = await Fingerprint2.getPromise();
        const visitorId = Fingerprint2.x64hash128(
          components.map((comp) => comp.value).join(","),
          31
        );

        const componentData = extractComponentData(components);

        setFingerprint({
          visitorId,
          timestamp: new Date().toISOString(),
          // Device & Browser Info
          deviceInfo: {
            browser: componentData.browser,
            osName: componentData.osName,
            cpuClass: componentData.cpuClass,
            deviceMemory: componentData.deviceMemory,
            webDriver: componentData.webDriver,
          },
          // Screen & Display Info
          displayInfo: {
            screenResolution: componentData.screenResolution,
            screenColorDepth: componentData.screenColorDepth,
            timezone: componentData.timezone,
          },
          // Raw user agent for backend parsing
          userAgent: componentData.userAgent,
          // All raw components for detailed analysis
          rawComponents: componentData,
        });
        setError(null);
      } catch (err) {
        console.error("Fingerprint error:", err);
        setError(err.message);
        setFingerprint(null);
      } finally {
        setLoading(false);
      }
    };

    getFingerprint();
  }, []);

  return { fingerprint, loading, error };
};
